const initialState = () => ({
  dialog: {
    onConfirm: () => {},
    options: [],
    show: false,
    text: '',
    type: 'none',
  },
});

const getters = {
  get: (state) => state.dialog,
};

const actions = {};

const mutations = {};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
